import { ConditionalOperator as i } from "../../../../node_modules/gridify-client/dist/index.esm.js";
import { isCaseSensitive as t } from "./utils/isCaseSensitive.js";
import { sanitizeUserInput as e } from "./utils/sanitizeUserInput.js";
const o = (i2) => "primitive" === i2.type, s = (o2, s2) => {
  const { key: r, op: n, value: d } = o2, m = e(d), p = n ? i[n] : i.Equal;
  return s2.addCondition(r, p, m, !t(n));
};
export {
  o as isPrimitive,
  s as serializePrimitive
};
//# sourceMappingURL=serializePrimitive.js.map
